import { createSlice } from "@reduxjs/toolkit";
import { logoutThunk } from "../user/userThunks";
import { brandingRequestThunk, instanceRequestThunk } from "./brandingThunks";
import { DEFAULT_BRANDING, sanitizeBrandingConfig } from "./brandingUtils";

const initialBrandingState = {
  config: sanitizeBrandingConfig(DEFAULT_BRANDING),
  loading: false,
  initialized: false,
  error: "",
  instanceConfig: null,
};

export const brandingSlice = createSlice({
  name: "branding",
  initialState: initialBrandingState,
  reducers: {
    resetBranding: (state) => ({ ...initialBrandingState, instanceConfig: state.instanceConfig, config: state.instanceConfig || initialBrandingState.config }),
  },
  extraReducers: (builder) => {
    builder.addCase(instanceRequestThunk.fulfilled, (state, action) => {
      state.instanceConfig = action.payload;
      state.config = action.payload || initialBrandingState.config;
    });
    builder.addCase(brandingRequestThunk.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(brandingRequestThunk.fulfilled, (state, action) => {
      state.config = sanitizeBrandingConfig(action.payload);
      state.loading = false;
      state.initialized = true;
      state.error = "";
    });
    builder.addCase(brandingRequestThunk.rejected, (state, action) => {
      state.config = state.instanceConfig || sanitizeBrandingConfig(DEFAULT_BRANDING);
      state.loading = false;
      state.initialized = true;
      state.error = action.payload?.http_status_code
        ? `http_error_${action.payload.http_status_code}`
        : "server_error";
    });
    builder.addCase(logoutThunk.fulfilled, (state) => ({ ...initialBrandingState, instanceConfig: state.instanceConfig, config: state.instanceConfig || initialBrandingState.config }));
  },
});

export const { resetBranding } = brandingSlice.actions;

export const selectBranding = (state) => state.branding;
export const selectBrandingConfig = (state) => state.branding.config;
export const selectBrandingLoading = (state) => state.branding.loading;
export const selectBrandingInitialized = (state) => state.branding.initialized;
export const selectBrandingError = (state) => state.branding.error;
export const selectBrandDisplayName = (state) =>
  state.branding.config.display_name;
export const selectBrandLogoUrl = (state) => state.branding.config.logo_url;
export const selectBrandFaviconUrl = (state) => state.branding.config.favicon_url;

export default brandingSlice.reducer;
